import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AppSettingsService, ITicketConfiguration } from './app-settings.service';
import { HttpService as XSightHttpService } from './http.service';
import { ITagConfiguration } from './ticket.service';

@Injectable({ providedIn: 'root' })
export class GroupSettingsService {
  constructor(private http: XSightHttpService, private appSettings: AppSettingsService) {}
  /** Gets the ticket configuration */
  public getTicketConfiguration(): Observable<ITicketConfiguration> {
    return this.http.get<ITicketConfiguration>(this.appSettings.accountServiceUrl + 'config/ticketConfiguration/', {});
  }

  /** Update the ticket configuration */
  public updateTicketConfiguration = (value: ITicketConfiguration): Observable<ITicketConfiguration> => {
    return this.http.put<ITicketConfiguration>(
      this.appSettings.accountServiceUrl + `config/ticketConfiguration`,
      value
    );
  };

  /** Gets the tag configuration */
  // keeping same as tag
  public getTagConfiguration(): Observable<ITagConfiguration> {
    return this.http.get<ITagConfiguration>(this.appSettings.accountServiceUrl + 'config/tagConfiguration/', {});
  }

  /** Update the tag configuration */
  public updateTagConfiguration = (value: ITagConfiguration): Observable<ITagConfiguration> => {
    return this.http.put<ITagConfiguration>(this.appSettings.accountServiceUrl + 'config/tagConfiguration', value);
  };
}
